/**
 * Filet focusout AutoComplete (BL-0367) : fermer seulement si le focus va
 * clairement hors du widget. `relatedTarget` null (Safari / clic) → false,
 * le délai 150 ms de l’input gère le clic souris.
 */
export type U2000ShouldCloseAutoCompleteOnRelatedFocusInput = {
  relatedTarget: Node | null;
  isInsideContainer: boolean;
  isInsideDropdown: boolean;
  isInsideF8Panel: boolean;
};

export function u2000ShouldCloseAutoCompleteOnRelatedFocus(
  input: U2000ShouldCloseAutoCompleteOnRelatedFocusInput,
): boolean {
  if (input.relatedTarget == null) {
    return false;
  }
  return !input.isInsideContainer && !input.isInsideDropdown && !input.isInsideF8Panel;
}
